import React, { useEffect } from "react";
import { useState } from "react";
import { GetReservations } from "../../api";
import ReservationItem from "./ReservationItem";
import TopBar from "./TopBar";
import { useTranslation } from "../../../context/TranslationContext";

const MyReservations = ({
  ssr,
  data,
  checkLogin,
  setLoading,
  isAppWebView,
}) => {
  const {
    reservationsTab1,
    reservationsTab2,
    reservationsTab1Error,
    reservationsTab2Error,
  } = useTranslation();
  const [reservations, setReservations] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [passReservations, setPassReservations] = useState(0);
  const [activaTab, setActiveTab] = useState(0);
  console.log({ reservations });

  useEffect(() => {
    List();
  }, []);

  const List = () => {
    GetReservations(data.IsLogin.Token)
      .then((result) => {
        setReservations(result.data.data);
        setPassReservations(
          result.data.data.filter((x) => x.IsPass == 1).length,
        );
      })
      .catch();
  };

  //d25186573aea4deb3a049dfbfc431ddd

  useEffect(() => {
    setFiltered(
      reservations ? reservations.filter((x) => x.IsPass == activaTab) : false,
    );
  }, [activaTab, reservations]);

  return (
    <>
      <div className="bg-[#EDF6FB] py-8 lg:h-[calc(100vh-96px)] mb-16">
        <div className="container flex flex-col h-full">
          <TopBar
            setLoading={setLoading}
            checkLogin={checkLogin}
            isAppWebView={isAppWebView}
            customerName={reservations?.[0]?.musteri}
          />
          <div className="bg-white md:py-[38px] py-[20px] md:px-[48px] px-[20px] rounded-[30px] lg:overflow-y-auto flex-auto">
            <div className="flex items-center mb-[38px] flex-col sm:flex-row">
              <span
                className={`font-semibold md:text-[17px] text-[14px] text-dark leading-6 sm:mr-8 cursor-pointer ${
                  activaTab != 0 ? "opacity-50" : ""
                } `}
                onClick={() => setActiveTab(0)}
              >
                {reservationsTab1} (
                {reservations ? reservations.length - passReservations : 0})
              </span>
              <span
                className={`font-semibold md:text-[17px] text-[14px] text-dark leading-6 cursor-pointer ${
                  activaTab != 1 ? "opacity-50" : ""
                } `}
                onClick={() => setActiveTab(1)}
              >
                {reservationsTab2} ({passReservations})
              </span>
            </div>
            <div className="flex flex-col">
              {filtered &&
                filtered.map((res, key) => (
                  <ReservationItem
                    key={key}
                    data={res}
                    datax={data}
                    ssr={ssr}
                    auth={data.IsLogin}
                    list={List}
                  />
                ))}

              {filtered && filtered.length == 0 && activaTab == 0 && (
                <>{reservationsTab1Error}</>
              )}
              {filtered && filtered.length == 0 && activaTab == 1 && (
                <>{reservationsTab2Error}</>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyReservations;
